/* Navigation data for the O&M mega-dropdown, reused by the desktop and mobile menus. */
import {
  Gauge, Boxes, ClipboardList, CalendarCheck, Wrench, Activity, Microscope, FileBarChart,
} from "lucide-react";

export const OM_MODULE = [
  [Gauge, "O&M Dashboard", "/om/dashboard", "Command centre for your entire O&M operation"],
  [Boxes, "Asset Register", "/om/assets", "Equipment hierarchy, health scores, and warranty tracking"],
  [ClipboardList, "Daily Monitoring", "/om/daily-log", "Shift-wise readings and automated alerts"],
  [CalendarCheck, "Preventive Maintenance", "/om/preventive-maintenance", "Scheduled PM, work orders, and compliance tracking"],
  [Wrench, "Corrective Maintenance", "/om/corrective-maintenance", "Fault ticketing, SLA tracking, and CM analytics"],
  [Activity, "Reliability Analytics", "/om/reliability", "MTBF, MTTR, and 30/60/90-day reliability trends"],
  [Microscope, "Root Cause Analysis", "/om/rca", "Automated 5-Why RCA engine with PDF export"],
  [FileBarChart, "O&M Reports", "/om/reports", "Monthly, Equipment History, SLA, and Compliance reports"],
];

export const OM_SECTOR_LINKS = [
  ["Solar Power O&M", "solar-power"],
  ["Wind Energy O&M", "wind-energy"],
  ["Thermal Power Plant O&M", "thermal-power-plant"],
  ["Nuclear Power Plant O&M", "nuclear-power-plant"],
  ["Hydropower O&M", "hydropower-plant"],
  ["HVAC and MEP O&M", "hvac-and-mep-systems"],
  ["Oil and Gas O&M", "oil-and-gas"],
  ["Water Treatment O&M", "water-treatment-plant"],
  ["Roads and Highways O&M", "roads-and-highways"],
  ["Industrial and Manufacturing O&M", "industrial-and-manufacturing-plant"],
];
